var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}]}),(_vm.confirm.show)?_c('Confirm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }